// extracted by mini-css-extract-plugin
export default {"Inputs":"TerminarTrabajoBotes_Inputs__VJzLt","Input":"TerminarTrabajoBotes_Input__sQ6fR","message":"TerminarTrabajoBotes_message__aToRB"};